import basicController from 'servicestack/basic.controller.properties'
import templateUrl from 'servicestack/tags/tags-card.htm'
import iboxTemplateUrl from 'servicestack/tags/tags-ibox.htm'
import TagsPrompt from 'servicestack/tags/tags-prompt'
import AutoQuery from 'servicestack/auto-query/auto-query'
import config from 'servicestack/tags/_config'
import labels from 'servicestack/tags/_labels'

class controller {
    constructor() {
        const $ctrl = this;
        basicController($ctrl);
        const url = `QueryTags.json?Shard=${$ctrl.shard}&PrincipalId=${$ctrl.principalId}`;

        let options = {
            url,
            fields: 'TagKind,TagLabel',
            autoLoad: !$ctrl.tags && !!$ctrl.principalId,
            append: false,
            onLoaded(args) {
                const m = $ctrl.tags = {};
                args.results.forEach(r => {
                    if (!m[r.tagKind]) m[r.tagKind] = [];
                    m[r.tagKind].push(r.tagLabel);
                });
            }
        };
        $ctrl.query = new AutoQuery(options);
    }

    editTags() {
        const $ctrl = this;
        return TagsPrompt.open({
            title: $ctrl.principalId + " " + ($ctrl.title || "Tags..."),
            tagKinds: $ctrl.tagKinds,
            principalId: $ctrl.principalId,
            shard: $ctrl.shard,
            tags: $ctrl.tags
        }).then(() => $ctrl.query.load(true));
    }
}

export default {
    bindings: {
        title: '@',
        principalId: '<',
        shard: '@',
        preventEdit: '@',
        ngModel: '<',
        tagKinds: '<?'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || ($attrs.ibox ? iboxTemplateUrl : templateUrl);
    }
};